import { render, staticRenderFns } from "./EventEdit.vue?vue&type=template&id=027b5ae4&scoped=true"
import script from "./EventEdit.vue?vue&type=script&lang=js"
export * from "./EventEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027b5ae4",
  null
  
)

export default component.exports